/* Kazne -> komentari u Excelu psihofizičkog, USKLAĐENO sa makroom kolega (desni klik u Excelu na produkciji):
   isti tekstovi po opsezima i iste boje — CRVENA upravljanje / pauze, ZELENA odmori, LJUBICASTA noćni rad,
   ZUTA "Nije povezao pauzu na tahografu."; bez boje kartica / OUT / "Ne povezuje pauze na tahografu.".
   Boja ide na ceo raspon dana prekršaja, komentar na dan u kome se završava (kao njihovi izveštaji).
   Napomene koje važe za vozača (nije koristio OUT, kartica, ne povezuje pauze) idu na ime vozača (kao njihovi izveštaji).
   Prekršaji kojih u makrou nema (14h, 56h, 90h, noćna vožnja 3h, kasno započet nedeljni...) zadržavaju naš tekst, bez boje.
   Svaki komentar kazne počinje propisom vozača: "Turistika: ..." (AETR + međugradski) ili "Gradski: ..." (dbo.Driver.Turistika). */
import { fmtTrajanje } from './engine/motor';
import { fmtDate } from '../../utils/dates';

const MIN = 60000;
const H = 60 * MIN;
const DAN = 24 * H;
const p2 = (n) => String(n).padStart(2, '0');
const ymd = (t) => { const d = new Date(t); return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`; };
const min = (ms) => Math.round(Math.max(0, ms) / MIN);

/* napomene na imenu vozača (kao kolege u Excelu) */
/* nepoznata aktivnost ide na DAN (kolege 2026-10-23: "Nije povezao pauzu na tahografu ... Mora ovako da zabeleži nepoznatu"), ne na ime */
const VOZAC = { g_out: 'Nije koristio OUT.', istekKartice: 'Vozio sa isteklom karticom.', g_istekKartice: 'Vozio sa isteklom karticom.' };

/* G1 — prekoračenje upravljanja (ukupna dnevna vožnja) */
const g1 = (t) => (t > 10 * H ? 'Prekoracenje upravljanja vozilom vise od 10h.'
    : t > 9 * H ? 'Prekoracenje upravljanja vozilom vise od 9h a manje od 10h.'
        : 'Prekoracenje upravljanja vozilom vise od 8h a manje od 9h.');

/* G2 — upravljanje bez pauze od 45 min (neprekidna vožnja) */
const g2 = (t) => (t >= 6 * H ? 'Upravljao je vozilom vise od 06:00h bez pauze od 45min.'
    : t >= 5 * H ? 'Upravljao je vozilom vise od 05:00h do 05:59h bez pauze od 45min.'
        : t >= 4 * H + 45 * MIN ? 'Upravljao je vozilom vise od 04:45h do 04:59h bez pauze od 45min.'
            : 'Upravljao je vozilom do 04:44h bez pauze od 45min.');

/* G3 — pauza u toku rada: makro ima "U 6h rada ... umesto 30min"; za 9h (45 min) i 12h (60 min) isti oblik */
const PAUZE = [
    { od: 12 * H, sati: 12, potrebno: 60, opsezi: [[45, 59], [30, 44], [1, 29]] },
    { od: 9 * H, sati: 9, potrebno: 45, opsezi: [[30, 44], [20, 29], [1, 19]] },
    { od: 0, sati: 6, potrebno: 30, opsezi: [[20, 29], [10, 19], [1, 9]] },
];
const g3 = (radno, pauza) => {
    const r = PAUZE.find((x) => radno > x.od);
    if (pauza <= 0) return `U ${r.sati}h rada nije imao ni minut pauze.`;
    const [a, b] = r.opsezi.find(([lo]) => pauza >= lo) || r.opsezi[r.opsezi.length - 1];
    return `U ${r.sati}h rada imao je pauzu od ${a}min do ${b}min umesto ${r.potrebno}min.`;
};

/* G4 — dnevni odmor: umesto 9h (dozvoljen skraćeni) kao makro; umesto 11h po istim stepenima Zakona (10h / 8h30) */
const g4 = (t, potrebno) => {
    if (potrebno <= 9 * H) {
        return t >= 8 * H ? 'Dnevni odmor vise od 8h manje od 9h umesto 9h.'
            : t >= 7 * H ? 'Dnevni odmor vise od 7h manje od 8h umesto 9h.'
                : 'Dnevni odmor manje od 7h umesto 9h.';
    }
    return t >= 10 * H ? 'Dnevni odmor vise od 10h manje od 11h umesto 11h.'
        : t >= 8.5 * H ? 'Dnevni odmor vise od 8h30min manje od 10h umesto 11h.'
            : 'Dnevni odmor manje od 8h30min umesto 11h.';
};

/* G5 — nedeljni odmor grad (24h skraćeni + 9h dnevni = 33h) */
const g5 = (t) => (t >= 31 * H ? 'Nedeljni odmor vise od 31h manje od 33h umesto 33h.'
    : t >= 29 * H ? 'Nedeljni odmor vise od 29h manje od 31h umesto 33h.'
        : 'Nedeljni odmor manje od 29h umesto 33h.');

/* G6 — nedeljni odmor turizam (AETR, 45h) */
const g6 = (t) => (t >= 42 * H ? 'Nedeljni odmor vise od 42h manje od 45h umesto 45h.'
    : t >= 36 * H ? 'Nedeljni odmor vise od 36h manje od 42h umesto 45h.'
        : 'Nedeljni odmor manje od 36h umesto 45h.');

/* G7 — noćni rad (radno vreme uz noćni rad, najviše 10h) */
const g7 = (t) => (t >= 13 * H ? 'Prekoracenje nocnog rada vise od 13h umesto 10h.'
    : t >= 11 * H ? 'Prekoracenje nocnog rada vise od 11h manje od 13h umesto 10h.'
        : 'Prekoracenje nocnog rada vise od 10h manje od 11h umesto 10h.');

/** { tekst, boja: 'CRVENA'|'ZELENA'|'LJUBICASTA'|'ZUTA'|null } */
function komentar(f) {
    const t = f.trajanje || 0;
    switch (f.tip) {
        case 'dnevnaVoznja':
        case 'g_dnevnaVoznja':
        case 'produzeniDani':
            return { tekst: g1(t), boja: 'CRVENA' };
        case 'pauza45': return { tekst: g2(t), boja: 'CRVENA' };
        case 'pauzeURadu': {
            const r = PAUZE.find((x) => t > x.od);
            return { tekst: g3(t, min(r.potrebno * MIN - (f.manjak || 0))), boja: 'CRVENA' };
        }
        case 'dnevniOdmor':
        case 'g_dnevniOdmor':
            /* tačan odmor u prozoru (kolege: "Dnevni odmor 08:52h umesto 9h.") */
            if (f.podtip === 'Nije u 24h' || f.podtip === 'Nije u 30h') {
                return { tekst: f.odmor != null ? `Dnevni odmor ${fmtTrajanje(f.odmor)}h umesto ${Math.round((f.potrebno || 9 * H) / H)}h.` : 'Dnevni odmor nije završen u roku od 24h.', boja: 'ZELENA' };
            }
            return { tekst: g4(t, t + (f.manjak || 0)), boja: 'ZELENA' };
        case 'skraceniOdmori':
        case 'g_skraceniOdmori':
            return { tekst: g4(t, 11 * H), boja: 'ZELENA' };
        case 'g_nedeljniOdmor': return { tekst: g5(t), boja: 'ZELENA' };
        case 'dvaSkracenaNedeljna':
        case 'nenadoknadjen':
            return { tekst: g6(t), boja: 'ZELENA' };
        case 'nocniRad':
        case 'g_nocniRad':
            return { tekst: g7(t), boja: 'LJUBICASTA' };
        case 'nepoznato':
        case 'g_nepoznato':
            /* nepoznata aktivnost (kartica izvađena bez ručnog unosa) i povezan ostali rad > 5h = pauza nije uneta na tahografu (žuto);
               radni dan bez unete zemlje početka — kolege: "... i nema početnu zemlju" */
            if (f.podtip === 'Bez početne zemlje') return { tekst: 'Nema početnu zemlju.', boja: 'ZUTA' };
            return { tekst: 'Nije povezao pauzu na tahografu.', boja: 'ZUTA' };
        /* nema ih u makrou — naš tekst, bez boje */
        case 'kasnoNedeljni':
        case 'g_kasnoNedeljni':
            return { tekst: `Kasno započet nedeljni odmor (${fmtTrajanje(f.prekoracenje || 0)}h).`, boja: null };
        case 'nedeljnaVoznja': return { tekst: `Nedeljno upravljanje vozilom ${fmtTrajanje(t)}h.`, boja: null };
        case 'dvonedeljnaVoznja':
        case 'g_dvonedeljnaVoznja':
            return { tekst: `Upravljanje vozilom u dve nedelje ${fmtTrajanje(t)}h.`, boja: null };
        case 'radnoVreme':
        case 'g_radnoVreme':
            return { tekst: `Radno vreme ${fmtTrajanje(t)}h.`, boja: null };
        case 'nocnaVoznja': return { tekst: `Noćna vožnja ${fmtTrajanje(t)}h.`, boja: null };
        case 'g_kvar': return { tekst: 'Kvar tahografa.', boja: null }; // kao kolege, umesto kazne za vožnju
        default: return { tekst: `${f.tipNaziv}.`, boja: null };
    }
}

/** @param prekrsaji lista iz izracunajPrekrsaje (sa tolerancija: true); @param drivers [{id, cardExpiry}] iz kazneApi.data; @param to kraj perioda (Date) */
export function psihoKomentari(prekrsaji, drivers, to) {
    const dani = [];
    const vozaci = [];
    const turistika = new Map((drivers || []).map((d) => [d.id, d.turistika]));
    const propis = (f) => {
        const t = turistika.get(f.driverId);
        if (t === true) return 'Turistika: ';
        if (t === false) return 'Gradski: ';
        return f.rezim === 'RS_G' ? 'Gradski: ' : 'Turistika: ';
    };
    for (const f of prekrsaji) {
        if (VOZAC[f.tip] && f.podtip !== 'Povezan ostali rad') {
            vozaci.push({ driverId: f.driverId, tekst: propis(f) + VOZAC[f.tip] });
            continue;
        }
        const od = f.od.getTime(); const doo = f.do.getTime();
        const kraj = doo > od ? doo - 1 : doo; // kraj u 00:00 pripada prethodnom danu
        const { tekst, boja } = komentar(f);
        dani.push({ driverId: f.driverId, od: ymd(od), do: ymd(kraj), tekst: propis(f) + tekst, boja });
    }
    /* kartica ističe u narednih 60 dana posle perioda (kao produkcija: "Ističe kartica 14.08.2026.") */
    const granica = new Date(to).getTime() + 60 * DAN;
    for (const d of drivers || []) {
        const exp = d.cardExpiry ? new Date(d.cardExpiry).getTime() : null;
        if (exp && exp <= granica && exp >= new Date(to).getTime() - 30 * DAN) vozaci.push({ driverId: d.id, tekst: `Ističe kartica ${fmtDate(new Date(exp))}.` });
    }
    return { dani, vozaci };
}

